import { EnterpriseOption } from '@app/core/interfaces/enterprise-option';
import { applicationEvent } from './application-event-factory';

export enum EventType {
  AllowedDeviceChanged = 'AllowedDeviceChanged',
  AssignedAllowedDeviceChanged = 'AssignedAllowedDeviceChanged',
  AssignedDownloadChanged = 'AssignedDownloadChanged',
  AssignedFeatureProfilesChanged = 'AssignedFeatureProfilesChanged',
  DownloadChanged = 'DownloadChanged',
  EndUserChanged = 'EndUserChanged',
  EndUserLoginNameChanged = 'EndUserLoginNameChanged',
  FeatureChanged = 'FeatureChanged',
  OptionalFeatureChanged = 'OptionalFeatureChanged',
  TrunkUsersChanged = 'TrunkUsersChanged',
  TrunkUsersChangedAfterBulkAction = 'TrunkUsersChangedAfterBulkAction',
  UserAssignedToTeamsTrunk = 'UserAssignedToTeamsTrunk',
  EndUserRichPresenceStatusChanged = 'EndUserRichPresenceStatusChanged',
  EndUserPhoneNumberChanged = 'EndUserPhoneNumberDeleted',
  EnterpriseChanged = 'EnterpriseChanged',
  EnterpriseOptionsChanged = 'EnterpriseOptionsChanged',
  FilesChanged = 'FilesChanged',
  EndUserFeatureProfileChanged = 'EndUserFeaturePro',
  NewUnseenNotification = 'NewUnseenNotification',
}

// Assigned feature profile changed
export const AssignedFeatureProfilesChangedEvent = applicationEvent<
  EventType.AssignedFeatureProfilesChanged,
  AssignedFeatureProfilesChangedPayload
>(EventType.AssignedFeatureProfilesChanged);

interface AssignedFeatureProfilesChangedPayload {
  enterpriseId: string;
}

// Feature changed
export const FeatureChangedEvent = applicationEvent<EventType.FeatureChanged, FeatureChangedPayload>(
  EventType.FeatureChanged
);

interface FeatureChangedPayload {
  featureName: string;
  userId: number;
}

// End user login name changed
export const EndUserLoginNameChangedEvent = applicationEvent<
  EventType.EndUserLoginNameChanged,
  EndUserLoginNameChangedPayload
>(EventType.EndUserLoginNameChanged);

interface EndUserLoginNameChangedPayload {
  oldLoginName: string;
  newLoginName: string;
}

// End user changed
export const EndUserChangedEvent = applicationEvent<EventType.EndUserChanged, EndUserChangedPayload>(
  EventType.EndUserChanged
);

interface EndUserChangedPayload {
  loginName: string;
}

// Optional feature changed
export const OptionalFeatureChangedEvent = applicationEvent<
  EventType.OptionalFeatureChanged,
  OptionalFeatureChangedPayload
>(EventType.OptionalFeatureChanged);

export interface OptionalFeatureChangedPayload {
  featureName: string;
}

// User has been assigned to a teams trunk
export const UserAssignedToTeamsTrunkEvent = applicationEvent<
  EventType.UserAssignedToTeamsTrunk,
  UserAssignedToTeamsTrunkPayload
>(EventType.UserAssignedToTeamsTrunk);

interface UserAssignedToTeamsTrunkPayload {
  loginName: string;
}

// User has been assigned to a trunk
export const TrunkUsersChangedEvent = applicationEvent<
  EventType.TrunkUsersChanged,
  UserAssignedToTrunkPayload
>(EventType.TrunkUsersChanged);

interface UserAssignedToTrunkPayload {
  loginName: string;
  trunkId?: string;
  type?: 'add' | 'remove';
}

export const TrunkUsersChangedAfterBulkActionEvent = applicationEvent(
  EventType.TrunkUsersChangedAfterBulkAction
);

export const EndUserRichPresenceStatusChangedEvent = applicationEvent(
  EventType.EndUserRichPresenceStatusChanged
);

export const EndUserPhoneNumberChangedEvent = applicationEvent(EventType.EndUserPhoneNumberChanged);

export const DownloadChanged = applicationEvent(EventType.DownloadChanged);
export const AssignedDownloadChanged = applicationEvent(EventType.AssignedDownloadChanged);
export const FilesChanged = applicationEvent(EventType.FilesChanged);

export const AssignedAllowedDeviceChanged = applicationEvent(EventType.AssignedAllowedDeviceChanged);
export const AllowedDeviceChanged = applicationEvent(EventType.AllowedDeviceChanged);

export const EnterpriseChanged = applicationEvent(EventType.EnterpriseChanged);

export const EnterpriseOptionsChanged = applicationEvent<
  EventType.EnterpriseOptionsChanged,
  EnterpriseOptionsChangedPayload
>(EventType.EnterpriseOptionsChanged);
interface EnterpriseOptionsChangedPayload {
  old: EnterpriseOption[];
  new: EnterpriseOption[];
}
export const EndUserFeatureProfileChanged = applicationEvent(EventType.EndUserFeatureProfileChanged);

export const NewUnseenNotification = applicationEvent<
  EventType.NewUnseenNotification,
  {
    since?: Date;
  }
>(EventType.NewUnseenNotification);
